// extracted by mini-css-extract-plugin
export default {"createdBy":"CreatedBy_createdBy__IxihZ"};